import React from 'react';
import {injectIntl} from "react-intl";

class LabeledText extends React.Component {

  render() {
    const {intl:{formatMessage}, label, text} = this.props;

    return (
      <div>
        <div><b>{formatMessage({id: label})}</b>: {text}</div>
      </div>
    )
  }
}

export default injectIntl(LabeledText);
